/*
 * color-slider
 */
import { cn } from "@timeprox/react/helpers"
import { cva } from "class-variance-authority"
import { useState } from "react"

export type ColorSliderProps = {
	initialColor?: string
	className?: string
	onColorChange?: (color: string) => void
}

export function ColorSlider({
	initialColor,
	className,
	onColorChange,
}: ColorSliderProps) {
	const [color, setColor] = useState(initialColor ?? "180")

	function handleOnChange(e: React.ChangeEvent<HTMLInputElement>) {
		e.preventDefault()
		const hue = e.target.value
		const newColor = `hsl(${hue}, 100%, 50%)`
		setColor(hue)
		if (onColorChange) {
			onColorChange(newColor)
		}
	}

	return (
		<input
			id={"color-slider"}
			className={cn([colorSliderVariants({ className }), "h-4 w-full rounded"])}
			value={color}
			type={"range"}
			style={
				{
					"--track-color": `hsl(${color}, 100%, 50%)`,
					"--thumb-color": `hsl(${color}, 100%, 50%)`,
				} as any
			}
			min={"0"}
			max={"360"}
			step={"1"}
			onChange={handleOnChange}
		/>
	)
}

/* Variants */
export const colorSliderVariants = cva("border", {
	variants: {
		rounded: {
			default: "rounded-md",
			sm: "rounded-xs",
			lg: "rounded-lg",
		},
		size: {
			default: "size-5",
			sm: "size-4",
			lg: "size-6",
		},
	},
	defaultVariants: {
		rounded: "default",
		size: "default",
	},
})
